import './App.css';
import Dictionary from './Dictionary';

function App() {
  return (
    <div className="App">
      <div className='container'>
        <Dictionary />
      </div>
      <footer className="text-center">
        Coded by <a href="https://dapper-stardust-7d2615.netlify.app/index.html" target="_blank" rel="noreferrer">Beatriz Barbosa</a> on <a href="https://github.com/beatrizmcbarbosa/dictionary-app" target="_blank" rel="noreferrer">GitHub</a>
      </footer>
    </div>
  );
}

export default App;
